import { ConnectedRouter } from 'connected-react-router';
import * as React from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import { store, history } from '../store/store';

import { MenuButton } from './menu-button/menu-button.container';
import { Navbar } from './navbar/navbar.container';
import { PagesStack } from './pages-stack/pages-stack.container';

export class App extends React.PureComponent {
  public render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Router>
            <div className="app">
              <MenuButton />

              <Navbar />

              <PagesStack />
            </div>
          </Router>
        </ConnectedRouter>
      </Provider>
    );
  }
}
